/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import {Col,Row, Form, Icon, Input, Button, Checkbox, message,Collapse } from 'antd';
import { post } from '../axios';
import title from '@/style/imgs/all/title.png';
import feima from '@/style/imgs/all/feima.png';
import yidian from '@/style/imgs/all/yidian.png';
import BreadcrumbCustom from './BreadcrumbCustom';

const FormItem = Form.Item;
const Panel = Collapse.Panel;

class Zpxx extends React.Component {
    state = {
        active:1,
        orderActive:"",
        title:"",
        data:[]
    };
    componentDidMount() {
        this.start();
    }
    start = () => {
        this.setState({ loading: true });
        post('/common/home-page-list.htm', {
            contType:3
        }).then(res => {
            const pagination = { ...this.state.pagination };
            pagination.total = res.data.total;
            this.setState({
                data: [...res.data.dataList.map(val => {
                    val.key = val.id;
                    return val;
                })],
                pagination,
                loading: false
            });
        });
    };
    render() {
        return (
            <div className="content-right">
                <BreadcrumbCustom first="飞马救援"  second="招聘信息"  />
                <div>
                        <Col>
                            <Col style={{width:"962px",paddingLeft:26,marginTop:46,height:650,overflow:"auto",background:"#fff",border:"1px solid #ccc"}}>
                                <Col style={{overflow:"hidden",paddingTop:46}}><img style={{float:"left",marginTop:6}} src={title} alt=""/><span style={{fontWeight:"bold",marginLeft:8,fontSize:18,color:"#282828",float:"left"}}>招聘信息</span></Col>
                                <Col style={{borderBottom:"1px solid #ddd",marginTop:20,width:880}}></Col>
                                <Collapse   style={{width:880}} accordion>
                                    {this.state.data.map((list,index) =>
                                        <Panel className="zpxxHead" style={{color:"#666"}}  header={list.title} key={index+1}>
                                            <Col style={{fontSize:14,color:"#666"}}>
                                                <Col style={{marginTop:12,fontSize:14,color:"#333"}}>岗位职责</Col>
                                                {list.treatment.split("；").map((val,index) =>
                                                    val?<Col style={{lineHeight:"40px"}}>{index+1}、{val};</Col>:""
                                                )}
                                                <Col style={{marginTop:12,fontSize:14,color:"#333"}}>任职资格</Col>
                                                {list.content.split("；").map((val,index) =>
                                                    val?<Col style={{lineHeight:"40px"}}>{index+1}、{val};</Col>:""
                                                )}
                                                <Col style={{marginTop:28}}><span style={{color:"#333"}}>工作地点：</span>{list.workplace}</Col>
                                            </Col>
                                        </Panel>
                                    )}
                                </Collapse>
                            </Col>
                        </Col>
                </div>
            </div>


        );
    }
}



export default Zpxx;


// WEBPACK FOOTER //
// ./src/components/zpxx.jsx